export const INVITE_MEMBER = 'INVITE_MEMBER'
export const GET_MEMBER_BY_KEY = 'GET_MEMBER_BY_KEY'
export const UPDATE_MEMBER = 'UPDATE_MEMBER'
export const GET_COMPENSATION = 'GET_COMPENSATION'
export const ADD_COMPENSATION = 'ADD_COMPENSATION'
export const ARCHIVE_COMPENSATION = 'ARCHIVE_COMPENSATION'
export const UPDATE_COMPENSATION_TYPE = 'UPDATE_COMPENSATION_TYPE'
export const CREATE_MEMBER = 'CREATE_MEMBER'
export const LOAD_ACTIVE_MEMBERS = 'LOAD_ACTIVE_MEMBERS'
export const SET_ACTIVE_MEMBERS = 'SET_ACTIVE_MEMBERS'
export const SET_ACTIVE_MEMBERS_REQUEST = 'SET_ACTIVE_MEMBERS_REQUEST'
export const RESET_ACTIVE_MEMBERS = 'RESET_ACTIVE_MEMBERS'
